import { PunchCard } from './PunchCard';
import { User } from './User';

export interface PunchCardSummary {
  workingTime: number;
	onClock: boolean;
}

export interface PunchCardsForDriver {
  punchCards: PunchCard[];
  summary: PunchCardSummary;
}

export const getWorkTimeForDriver = (pc?: PunchCardsForDriver): string => {
  if (!pc) return 'NA';

  const diff = pc.summary.workingTime;

  return `${(diff / 60).toFixed(2)} hrs`;
}

export interface PunchCardsForAllDrivers {
  summary: PunchCardsForDriver;
	driver: User;
}
